import { Component, OnInit } from '@angular/core';
import { AlertType } from '../models/alert-type';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.css'],
    standalone: false
})
export class ToastComponent implements OnInit {

  toasts: { message: string; type: AlertType; timestamp: number, backgroundClass: string }[] = [];
  AlertType = AlertType;

  constructor() { }

  ngOnInit() {

  }

  addToast(toastData: {message: string, type: AlertType}) {
    this.toasts.push({
      message: toastData.message,
      type: toastData.type,
      timestamp: Date.now(),
      backgroundClass: this.getBackgroundClass(toastData.type)
    });
  }

  removeToast(toast: { message: string; type: AlertType; timestamp: number, backgroundClass: string }) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  private getBackgroundClass(type: AlertType): string {
    let bgClass = '';
    switch(type) {
      case AlertType.SUCCESS:
        bgClass = 'text-bg-success';
        break;
      case AlertType.WARNING:
        bgClass = 'text-bg-warning';
        break;
      case AlertType.ERROR:
        bgClass = 'text-bg-danger';
        break;
      case AlertType.INFO:
        bgClass = 'text-bg-info';
        break;
    }
    return bgClass;
  }
}
